import React from 'react';
import { useSnackbar } from '../contexts/SnackbarContext';
import Button from './ui/Button';
import SnackbarService from '../services/SnackbarService';

const DebugSection = () => {
    const { showSnackbar, showSuccess, showError, showWarning, showInfo } = useSnackbar();

    const handleServiceOperation = async () => {
        try {
            // This will show a success notification through the service
            await SnackbarService.performOperation('Data processing');
        } catch (error) {
            console.error('Operation failed:', error);
        }
    };

    const handleServiceError = () => {
        // Directly use the service to show notifications
        SnackbarService.showError('This error comes from the SnackbarService!');
    };

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">Debug Tools</h1>

            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-3">Snackbar Demo (React Hooks)</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <Button
                        onClick={() => showSuccess('Operation completed successfully!')}
                        variant="primary"
                    >
                        Show Success
                    </Button>
                    <Button
                        onClick={() => showError('Something went wrong!')}
                        variant="danger"
                    >
                        Show Error
                    </Button>
                    <Button
                        onClick={() => showWarning('Please be careful!')}
                        variant="warning"
                    >
                        Show Warning
                    </Button>
                    <Button
                        onClick={() => showInfo('Here is some information')}
                        variant="secondary"
                    >
                        Show Info
                    </Button>
                    <Button
                        onClick={() => showSnackbar('Custom message with long duration', 'info', 10000)}
                        variant="secondary"
                    >
                        Long Duration (10s)
                    </Button>
                </div>
            </div>

            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-3">Snackbar Service Demo (Non-React Code)</h2>
                <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                    <Button
                        onClick={handleServiceOperation}
                        variant="primary"
                    >
                        Service Operation
                    </Button>
                    <Button
                        onClick={handleServiceError}
                        variant="danger"
                    >
                        Service Error
                    </Button>
                    <Button
                        onClick={() => SnackbarService.showWarning('Warning from service!')}
                        variant="warning"
                    >
                        Service Warning
                    </Button>
                    <Button
                        onClick={() => SnackbarService.showInfo('Info from service')}
                        variant="secondary"
                    >
                        Service Info
                    </Button>
                </div>
            </div>

            <div className="bg-gray-100 p-4 rounded-md">
                <h2 className="text-lg font-semibold mb-2">Debug Information</h2>
                <p>Application version: 1.0.0</p>
                <p>Environment: {process.env.NODE_ENV}</p>
                <p>Current time: {new Date().toLocaleString()}</p>
            </div>
        </div>
    );
};

export default DebugSection; 